/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

/* eslint-disable import/prefer-default-export */

import Jsona from 'jsona';
import Types from '../constants/actionTypes';
import * as API from '../utils/api';
import { applicationError } from './notificationActions';

const dataFormatter = new Jsona();

export function fetchAllTaskTypes() {
  return dispatch => {
    dispatch({ type: Types.REQUEST_TASK_TYPE });
    return API.get('task_types')
      .then(response => {
        const taskTypes = dataFormatter.deserialize(response);
        dispatch({ type: Types.RECEIVE_ALL_TASK_TYPES, taskTypes });
        dispatch({ type: Types.ADD_TASK_TYPE_TO_TASKS, taskTypes });
      })
      .catch(error => dispatch(applicationError(error)));
  };
}
